import { render, staticRenderFns } from "./ProductDeliveryTime.vue?vue&type=template&id=66ef7d4a&scoped=true"
import script from "./ProductDeliveryTime.vue?vue&type=script&lang=js"
export * from "./ProductDeliveryTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ef7d4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ef7d4a')) {
      api.createRecord('66ef7d4a', component.options)
    } else {
      api.reload('66ef7d4a', component.options)
    }
    module.hot.accept("./ProductDeliveryTime.vue?vue&type=template&id=66ef7d4a&scoped=true", function () {
      api.rerender('66ef7d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductDeliveryTime.vue"
export default component.exports